<div class="rc-dialog">

  <div class="rc-header">
    <h2 class="rc-title">Restaurant Configuration</h2>
    <button class="rc-close" mat-icon-button (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <form [formGroup]="form" (ngSubmit)="save()">

    <div class="rc-row">
      <mat-form-field class="my-form-field-color rc-field" appearance="fill" subscriptSizing="dynamic">
        <mat-label>Restaurant Code</mat-label>
        <input matInput formControlName="code" maxlength="1" />
        @if (form.get('code')?.hasError('duplicateCode')) {
          <mat-error>This code is already in use for the selected ship.</mat-error>
        } @else if (form.get('code')?.touched && form.get('code')?.invalid) {
          <mat-error>Code is required (1 character).</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="my-form-field-color rc-field rc-field--wide" appearance="fill" subscriptSizing="dynamic">
        <mat-label>Restaurant Name</mat-label>
        <input matInput formControlName="name" maxlength="50" />
        @if (form.get('name')?.touched && form.get('name')?.invalid) {
          <mat-error>Name is required (max 50 characters).</mat-error>
        }
      </mat-form-field>

      <mat-form-field class="my-form-field-color rc-field" appearance="fill" subscriptSizing="dynamic">
        <mat-label>Ship</mat-label>
        <mat-select formControlName="ship">
          @for (ship of data.ships; track ship.id_ship) {
            <mat-option [value]="ship.id_ship">{{ ship.ship_name }}</mat-option>
          }
        </mat-select>
        @if (form.get('ship')?.touched && form.get('ship')?.invalid) {
          <mat-error>Ship is required.</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="rc-shifts-head">
      <span class="rc-section-title">Seating Configuration</span>
    </div>

    <div class="rc-add-row">
        <button type="button" class="rc-add-btn" mat-button (click)="addShift()">
          <mat-icon>add</mat-icon>
          <span>Add Row</span>
        </button>
      </div>
    <div class="rc-shifts" formArrayName="shifts">

      <div class="rc-shifts-labels">
        <span>Seating Code</span>
        <span>Dinner Start</span>
        <span>Dinner End</span>
        <span class="rc-action-col">Action</span>
      </div>

      @for (shift of shifts.controls; let i = $index; track shift) {
        <div class="rc-shift-row" [formGroupName]="i">
          <mat-form-field class="my-form-field-color rc-shift-field" appearance="fill" subscriptSizing="dynamic">
            <input matInput formControlName="code" maxlength="1" placeholder="Code" />
          </mat-form-field>

          <mat-form-field class="my-form-field-color rc-shift-field" appearance="fill" subscriptSizing="dynamic">
            <input matInput formControlName="start" appTimeMask placeholder="HH:MM" maxlength="5" inputmode="numeric" />
            @if (shift.get('start')?.touched && shift.get('start')?.hasError('pattern')) {
              <mat-error>Enter a valid 24h time (HH:MM).</mat-error>
            }
          </mat-form-field>

          <mat-form-field class="my-form-field-color rc-shift-field" appearance="fill" subscriptSizing="dynamic">
            <input matInput formControlName="end" appTimeMask placeholder="HH:MM" maxlength="5" inputmode="numeric" />
            @if (shift.get('end')?.touched && shift.get('end')?.hasError('pattern')) {
              <mat-error>Enter a valid 24h time (HH:MM).</mat-error>
            }
          </mat-form-field>

          <button type="button" class="rc-delete-btn" mat-icon-button
                  (click)="removeShift(i)" aria-label="Remove shift">
            <mat-icon>delete</mat-icon>
          </button>

          @if (shiftHasTimeError(i)) {
            <span class="rc-shift-error">End time must be later than start time.</span>
          }
        </div>
      }

      @if (shifts.errors?.['duplicateShiftCode']) {
        <p class="rc-error">Seating codes must be unique within the restaurant.</p>
      }

      @if (showMinShiftError) {
        <p class="rc-error">You must have at least one seating at the restaurant.</p>
      }

      
    </div>

    <div class="rc-actions">
      <button type="submit" class="my-button confirm" mat-raised-button [disabled]="form.invalid">SAVE</button>
    </div>

  </form>
</div>
